module.exports = __webpack_public_path__ + "img/PaymentSucessfull.665c3ac6.svg";